<template>
	<div class="seeker-container">
		<template v-if="$vuetify.breakpoint.smAndDown">
			<v-btn
				fab
				elevation="0"
				color="transparent"
				@click="ui.show = !ui.show"
				:small="$vuetify.breakpoint.mdAndUp"
			>
				<v-icon class="white--text">
					mdi-magnify
				</v-icon>
			</v-btn>
		</template>

		<div
			class="seeker-content"
			v-if="
				(ui.show && $vuetify.breakpoint.smAndDown) ||
					$vuetify.breakpoint.mdAndUp
			"
		>
			<v-btn
				fab
				text
				class="elevation-0 mr-2 animate__animated animate__fadeInLeft animate__faster white--text"
				v-if="$vuetify.breakpoint.smAndDown"
				@click="ui.show = false"
			>
				<v-icon>
					mdi-arrow-left
				</v-icon>
			</v-btn>

			<v-text-field
				label="¿Qué esta buscando hoy?"
				filled
				clearable
				hide-details
				autocomplete="off"
				v-model="criterion"
				@keyup="search()"
				@click:clear="clear()"
				background-color="#fff"
				:class="[
					'seeker-text-field animate__animated',
					{
						'animate__fadeInRight animate__faster':
							$vuetify.breakpoint.smAndDown,
					},
				]"
				:dense="$vuetify.breakpoint.mdAndUp"
				rounded
				:autofocus="$vuetify.breakpoint.smAndDown"
				:solo="$vuetify.breakpoint.smAndDown"
			></v-text-field>

			<div
				v-if="data.results.length"
				class="results-container elevation-20 animate__animated animate__fadeIn animate__faster"
			>
				<div class="results-group" v-for="result in data.results">
					<div
						class="name d-flex justify-space-between align-center pa-2 pt-3 pb-3 pr-3"
						style="background-color: rgba(0, 0, 0, .05); letter-spacing: 1px;"
					>
						{{ `${result.category}` }}

						<v-btn
							rounded
							text
							color="primary"
							small
							@click="showCategory(result.category_id)"
						>
							Ver todo
						</v-btn>
					</div>

					<div class="results-group-content">
						<div
							class="result"
							v-for="product in result.products"
							@click="showProduct(product.id)"
						>
							<div class="name">
								{{ product.name }}
							</div>

							<p class="text">
								{{ product.description }}
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
import { mapGetters } from "vuex";
import Fuse from "fuse.js";

export default {
	name: "Seeker",

	data() {
		return {
			criterion: null,

			results: [],

			data: {
				results: [],
			},

			ui: {
				searching: false,
				show: false,
			},
		};
	},

	created() {
		if (this.$store.state.authenticated) {
			this.$store.dispatch(
				"getArticles",
				this.$store.state.acount.user.customer.id
			);
		} else {
			this.$store.dispatch("getArticles", null);
		}
	},

	methods: {
		search() {
			var results = [];

			let fuse = new Fuse(this.getProducts, {
				// isCaseSensitive: false,
				// includeScore: false,
				// shouldSort: true,
				// includeMatches: false,
				// findAllMatches: false,
				// minMatchCharLength: 1,
				// location: 0,
				// threshold: 0.6,
				// distance: 100,
				// useExtendedSearch: false,
				// ignoreLocation: false,
				// ignoreFieldNorm: false,
				keys: ["name", "articles.description"],
			});

			let fuse_results = fuse
				.search(this.criterion)
				.map((item) => {
					let description = "";
					item = item.item;

					if (item.articles) {
						if (item.articles[0]) {
							description = item.articles[0].description;
						}
					}

					return {
						category: item.category.name,
						category_id: item.category.id,
						products: {
							id: item.id,
							name: item.name,
							description: description,
						},
					};
				})
				.splice(0, 7)
				.forEach((result) => {
					if (
						!results.find(
							(item) => item.category == result.category
						)
					) {
						results.push({
							category: result.category,
							category_id: result.category_id,
							products: [],
						});
					}

					let index = results.indexOf(
						results.find((item) => item.category == result.category)
					);

					results[index].products.push(result.products);
				});

			this.data.results = results;
		},

		showProduct(product_id) {
			this.$router.push({
				name: "PrductShow",
				params: { id: product_id },
			});

			this.clear();
		},

		showCategory(category_id) {
			this.$router.push({
				name: "Search",
				query: { categories: [category_id] },
			});

			this.clear();
		},

		clear() {
			this.data.results = [];
		},
	},

	computed: {
		...mapState({
			articles: (state) => state.articles,

			articlesGeting: (state) => state.ui.articlesGeting,
		}),

		...mapGetters(["getProducts"]),
	},
};
</script>

<style lang="css" scoped>
.seeker-container {
	/*position: relative;*/
}

.seeker-content {
	position: relative;
	width: 450px;
}

.seeker-text-field {
	width: 100%;
}

/*Results*/
.result:hover {
	background-color: #eee;
}

.result::hover .name {
	font-size: 12px;
}

.results-container {
	left: 0;
	max-height: 450px;
	width: 100%;
	overflow-y: scroll;
	position: absolute;
	top: calc(100% + 5px);
	background-color: #fff;
}

.text {
	color: #777;
	font-size: 12px;
}

.results-group,
.result {
	cursor: pointer;
	padding: 7px 0 7px 10px;
	transition: all 0.3s;
}

.results-group {
	padding: 0;
	border-bottom: 1px solid #eee;
}

.results-group > .name {
	position: relative;
	font-weight: 600;
	font-size: 12px;
}

.result > .name {
	font-size: 14px;
}

.results-group-content {
	/*padding-left: 10px;*/
}

/*Extra small < 600px*/
@media (min-width: 0) and (max-width: 960px) {
	.seeker-content {
		right: 0;
		top: 0;
		width: 100%;
		/*padding-bottom: 10px;*/
		padding: 0 8px;
		position: absolute;
		z-index: 5;
		display: flex;
		align-items: center;
		height: 90px;
		background-color: #005cb9;
		/*border-bottom: 1px solid #ccc;*/
	}
}

/*Medium	md	Large tablet to laptop	960px > < 1264px**/
@media (min-width: 961px) and (max-width: 1264px) {
}

/*Large	lg	Desktop	1264px > < 1904px**/
@media (min-width: 1265px) and (max-width: 1904px) {
}

/*Extra large	xl	4k and ultra-wide*/
@media (min-width: 1904px) {
}
</style>
